/*
* Order/Notification API
* */

import {
    RequestConfigFunction,
} from 'app/types/request.types'

type OrderNotificationRequests = {
    getNotificationDispatchContent: RequestConfigFunction<{
        orderNumber: string,
        notificationId: string,
        dispatchNumber: string,
    }>,
    filterRequestAll: RequestConfigFunction<{
        orderNumber: string,
    } & Record<string, any>>,
    getNotificationDispatchContentOld: RequestConfigFunction<{
        notificationId: string,
        dispatchNumber: string,
    }>,
    filterRequestContainerSelection: RequestConfigFunction<{
        orderNumber: string,
    }>,
    filterRequestOrderStepAll: RequestConfigFunction<{
        orderNumber: string,
        orderStepId: number,
    }>,
    sendNotificationDispatch: RequestConfigFunction<{
        orderNumber: string,
        notificationId: string,
        dispatchNumber: string,
    }>,
}

const orderNotificationRequests: OrderNotificationRequests = {
    getNotificationDispatchContent: ({
        orderNumber,
        notificationId,
        dispatchNumber,
    }) => {
        return {
            url: `order/${orderNumber}/notification/${notificationId}/dispatch/${dispatchNumber}/content`,
            method: 'GET',
        }
    },
    filterRequestAll: ({
        orderNumber,
        ...params
    }) => {
        return {
            url: `order/${orderNumber}/notification/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    getNotificationDispatchContentOld: ({
        notificationId,
        dispatchNumber,
    }) => {
        return {
            url: `order/notification/${notificationId}/dispatch/${dispatchNumber}/contentold`,
            method: 'GET',
        }
    },
    filterRequestContainerSelection: ({
        orderNumber,
    }) => {
        return {
            url: `order/${orderNumber}/notification/filter-request/containerselection`,
            method: 'POST',
        }
    },
    filterRequestOrderStepAll: ({
        orderNumber,
        orderStepId,
    }) => {
        return {
            url: `order/${orderNumber}/orderstep/${orderStepId}/notification/filter-request/all`,
            method: 'POST',
        }
    },
    sendNotificationDispatch: ({
        orderNumber,
        notificationId,
        dispatchNumber,
    }) => {
        return {
            url: `order/${orderNumber}/notification/${notificationId}/dispatch/${dispatchNumber}/sending`,
            method: 'POST',
        }
    },
}

export default orderNotificationRequests
